import React, { useState, useEffect, forwardRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import teachersAPI from "../../../../services/teachers";
import classroomsAPI from "../../../../services/classrooms";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import slotsAPI from "../../../../services/slots";
import scheduleAPI from "../../../../services/schedule";
import { useParams } from "react-router-dom";

const UpdateScheduleModal = forwardRef((props, ref) => {
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const [teacher, setTeacher] = useState("-1");
  const [classroom, setClassroom] = useState("-1");
  const [slot, setSlot] = useState({
    id: "",
    startHour: "",
    endHour: "",
  });
  const [startHour, setStartHour] = useState("");
  const [endHour, setEndHour] = useState("");
  const [points, setPoints] = useState(0);
  //
  useEffect(() => {
    setTeacher(props?.schedule?.teacher_id || "-1");
    setClassroom(props?.schedule?.classroom_id || "-1");
    setSlot(props?.schedule?.slot?.id || "-1");
    setStartHour(props?.schedule?.start_hour || "");
    setEndHour(props?.schedule?.end_hour || "");
    setPoints(props?.schedule?.points ?? 0);
  }, [props]);

  //
  const slotsList = slotsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueSlots = slotsList.data?.data || [];
  uniqueSlots.sort((a, b) => a.show_order - b.show_order);
  const slots = uniqueSlots.map((slot, index) => ({
    key: slot.id,
    label: slot.name,
    value: slot.id,
    start_hour: slot.start_hour,
    end_hour: slot.end_hour,
    show_order: slot.show_order,
  }));
  slots.unshift({
    key: "empty-slot-key",
    label: "",
    value: "",
    start_hour: "",
    end_hour: "",
    show_order: 0,
  });
  //
  const teachersList = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => a.member.lastname - b.member.lastname);
  const teachers = uniqueTeachers.map((teacher, index) => ({
    key: teacher.id,
    label: teacher.member.name ? teacher.member.name : teacher.member.lastname + " " + teacher.member.firstname,
    value: teacher.id,
  }));
  teachers.unshift({
    key: "empty-teacher-key",
    label: "",
    value: "",
  });
  //
  const classroomsList = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueClassrooms = classroomsList.data?.data || [];
  uniqueClassrooms.sort((a, b) => a.name - b.name);
  const normalizeCapacity = (capacity) => {
    if (capacity === undefined || capacity === null || capacity === "") {
      return null;
    }
    const parsedCapacity = Number(capacity);
    return Number.isFinite(parsedCapacity) && parsedCapacity > 0 ? parsedCapacity : null;
  };

  const classrooms = uniqueClassrooms.map((classroom, index) => ({
    key: classroom.id,
    label: classroom.name,
    value: classroom.id,
  }));
  classrooms.unshift({
    key: "empty-classroom-key",
    label: "",
    value: "",
  });
  const classCapacity = normalizeCapacity(props?.schedule?.classe?.max_capacity);
  const selectedClassroom = uniqueClassrooms.find((item) => item.id === classroom);
  const classroomCapacity = normalizeCapacity(
    selectedClassroom?.capacity ?? props?.schedule?.classroom?.capacity
  );
  const hasCapacityOverflow =
    classCapacity !== null &&
    classroomCapacity !== null &&
    classCapacity > classroomCapacity;
  const hasClassCapacityBelowRoomCapacity =
    classCapacity !== null &&
    classroomCapacity !== null &&
    classCapacity < classroomCapacity;

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer une programmation"
        schoolId={schoolId}
        trainingId={trainingId}
        serviceAPI={scheduleAPI}
        dialogStyle={{ width: "45vw" }}
        id={props?.schedule?.id}
        data={{
          teacher_id: teacher === "-1" ? "" : teacher,
          classroom_id: classroom === "-1" ? "" : classroom,
          slot_id: slot === "-1" ? "" : slot,
          start_hour: startHour,
          end_hour: endHour,
          points: points ?? 0,
        }}
      >
        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="cours" className="block text-900 font-medium mb-2">
              Matière
            </label>
            <InputText
              id="cours"
              value={props?.schedule?.course?.name}
              className="w-full mb-3"
              disabled={true}
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="classe" className="block text-900 font-medium mb-2">
              Classe
            </label>
            <InputText
              id="classe"
              value={props?.schedule?.classe?.name}
              className="w-full mb-3"
              disabled={true}
            />
          </div>

        </div>
        {classCapacity !== null && (
          <div className="mb-3">
            <small className="text-600">
              Capacité de la classe : {classCapacity} places
              {hasClassCapacityBelowRoomCapacity && (
                <i
                  className="pi pi-exclamation-triangle ml-2"
                  style={{ color: "#f59e0b" }}
                ></i>
              )}
            </small>
          </div>
        )}
        <label htmlFor="Créneau" className="block text-900 font-medium mb-2">
          Créneau
        </label>
        <Dropdown
          id="Créneau"
          options={slots}
          value={slot || "-1"}
          onChange={(e) => {
            setSlot(e.value);
            // Find the selected slot to get start_hour and end_hour
            const selectedSlot = slots.find(s => s.value === e.value);
            if (selectedSlot) {
              setStartHour(selectedSlot.start_hour);
              setEndHour(selectedSlot.end_hour);
            }
          }}
          optionLabel="label"
          optionValue="value"
          placeholder="Select a slot"
          className="w-full mb-3"
        />
        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureDebut"
              className="block text-900 font-medium mb-2"
            >
              Heure de début
            </label>
            <InputText
              id="heureDebut"
              type="time"
              value={startHour}
              onChange={(e) => setStartHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureFin"
              className="block text-900 font-medium mb-2"
            >
              Heure de fin
            </label>
            <InputText
              id="heureFin"
              type="time"
              value={endHour}
              onChange={(e) => setEndHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
        </div>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="enseignant"
              className="block text-900 font-medium mb-2"
            >
              Enseignant(e)
            </label>
            <Dropdown
              id="enseignant"
              options={teachers}
              value={teacher || "-1"}
              onChange={(e) => setTeacher(e.value)}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a Teacher"
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="salle" className="block text-900 font-medium mb-2">
              Salle
            </label>
            <Dropdown
              id="salle"
              options={classrooms}
              value={classroom || "-1"}
              onChange={(e) => setClassroom(e.value)}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a Classroom"
              className="w-full mb-3"
            />
          </div>
        </div>
        {classroomCapacity !== null && (
          <div className="mb-3">
            <small className="text-600">
              Capacité de la salle : {classroomCapacity} places
              {hasCapacityOverflow && (
                <i
                  className="pi pi-exclamation-triangle ml-2"
                  style={{ color: "#f59e0b" }}
                ></i>
              )}
            </small>
          </div>
        )}
        <label htmlFor="points" className="block text-900 font-medium mb-2">
          Points
        </label>
        <InputNumber
          id="points"
          value={points}
          onValueChange={(e) => setPoints(e.value ?? 0)}
          mode="decimal"
          minFractionDigits={0}
          maxFractionDigits={2}
          min={0}
          className="w-full mb-1"
        />
        <small className="text-600">
          Points attribués à chaque séance de cette programmation. La
          modification est appliquée aux séances à venir.
        </small>
      </MeaUpdateModal>
    </>
  );
});

export default UpdateScheduleModal;
